export default __webpack_public_path__ + "static/media/3_hi_jiffy.93c13e42.svg";